import {Component, Input} from '@angular/core';

import {MatIcon} from '@angular/material/icon';
import {MatTooltip} from '@angular/material/tooltip';
import {MatProgressSpinner} from '@angular/material/progress-spinner';

@Component({
  selector: 'pub-sync-status-indicator',
  templateUrl: './sync-status-indicator.component.html',
  styleUrls: ['./sync-status-indicator.component.scss'],
  standalone: true,
  imports: [MatIcon, MatTooltip, MatProgressSpinner]
})
export class SyncStatusIndicatorComponent {
  @Input() status?: string;
  @Input() message: string = '';
}
